import {arrayToCsv} from '@netx/core-next/utils/array';
import type {SearchRule, SearchRules} from '../rules/types';

/**
 * Need to convert any arrays of values to csv
 * @param value Search rule value
 * @returns Corrected value
 */
const correctValueIfNeeded = (value: string | number | string[] | number[]) =>
	Array.isArray(value) ? arrayToCsv(value) : value;

/**
 * Convert _n_ rules to a combined search rules object
 * @param rules Search rules
 * @returns Combined search rules
 * @example
	convertToRules(
	    createKeywordRule({keyword: 'foo'}),
	    createKeywordRule({keyword: 'bar'}),
	);
	// {
	//	elementTypes: [4, 4],
	//	elementSubType1s: [4, 4],
	//	elementSubType2s: [0, 0],
	//	elementValue1s: ['foo', 'bar],
	//	elementValue2s: ['', ''],
	//	elementValue3s: ['', ''],
	// }
 */
export const convertToRules = (...rules: SearchRule[]) => {
	return rules.reduce<SearchRules>(
		(accum, rule, index) => {
			accum.elementTypes[index] = rule.elementType;
			accum.elementSubType1s[index] = rule.elementSubType1;
			accum.elementSubType2s[index] = rule.elementSubType2;
			accum.elementValue1s[index] = correctValueIfNeeded(rule.elementValue1);
			accum.elementValue2s[index] = correctValueIfNeeded(rule.elementValue2);
			accum.elementValue3s[index] = correctValueIfNeeded(rule.elementValue3);
			return accum;
		},
		{
			elementTypes: [],
			elementSubType1s: [],
			elementSubType2s: [],
			elementValue1s: [],
			elementValue2s: [],
			elementValue3s: [],
		},
	);
};

export default convertToRules;
